export default m => {
  const isTheSameMonth = m.startOf(`week`).month() === m.endOf(`week`).month()
  const isTheSameYear = m.startOf(`week`).year() === m.endOf(`week`).year()
  if (isTheSameMonth) {
    return `${m.startOf(`week`).date()} — ${m
      .endOf(`week`)
      .format(`D MMMM YYYY`)}`
  }
  if (isTheSameYear) {
    return `${m.startOf(`week`).format(`D MMMM`)} — ${m
      .endOf(`week`)
      .format(`D MMMM YYYY`)}`
  }
  return `${m.startOf(`week`).format(`D MMMM YYYY`)} — ${m
    .endOf(`week`)
    .format(`D MMMM YYYY`)}`
}
